export default "__VITE_ASSET__8b3f4a45__"